<div class="forgetPassword">
    <form>
        <div id="u" class="form-group">
            <div class="inner-addon left-addon">
                <i class="glyphicon flaticon-gmail-logo pull-right"></i>
                <input spellcheck=false class="form-control" [(ngModel)]="email" name="username" type="text" size="18"
                    alt="login" required>
                <span class="form-highlight"></span>
                <span class="form-bar"></span>
                <label for="username" class="float-label">E-mail</label>
            </div>
        </div>
        <p>
            Merci de consulter votre boite e-mail pour obtenir votre mot de passe.
        </p>
        <div class="form-group text-right">
            <div class="form-btn">
                <div class="wrap-form-btn">
                    <button class="signUp-btn" type="submit" (click)="send()" [disabled]="loader">
                        <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;</ng-container>
                        Envoyer
                    </button>
                </div>
                <a routerLink="../../connexion" class="login-btn">
                    Se connecter &nbsp;&nbsp;
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </a>
            </div>
        </div>
    </form>
</div>